<svg
  width="16"
  height="16"
  viewBox="0 0 16 16"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  class={$$props.class}
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M0.494751 13.3333L7.99924 0.694183L15.5037 13.3333H0.494751ZM8.66663 6.00001V9.33334H7.33329V6.00001H8.66663ZM7.33329 10H8.66663V11.3333H7.33329V10Z"
    fill="currentColor"
  />
</svg>
